import { createSlice } from "@reduxjs/toolkit";
import { updateStaffDetailWithId } from "../../api/staff";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const editStaffSlice = createSlice({
  name: "editStaff",
  initialState: data,
  reducers: {
   editStaffSlice(state) {
      state.isLoading = true;
    },
   editStaffSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    editStaffSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    editStaffSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});

export const editStaffHandler = (id:any, data:any) => async (dispatch: any) => {
  try {
    dispatch(editStaffAction.editStaffSlice());
    const response: any = await updateStaffDetailWithId(id, data);
    
    dispatch(editStaffAction.editStaffSliceSuccess(response));
  } catch (e: any) {
    dispatch(editStaffAction.editStaffSliceFailure(e?.response?.data));
  }
};

export default editStaffSlice.reducer;
export const editStaffAction = editStaffSlice.actions;
